<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 9.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2 class="m-0 p-0">Borderouri Automate</h2>
        </div>
    </div>
</div>

<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Borderouri Automate Programări</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('auth-module.ghiseu.borderou-automat.export')"
                                type="button" class="btn btn-sm btn-success pull-right ms-1" (click)="exportExcel()"
                                [disabled]="isExporting">
                                <i class="fa-solid fa-file-excel"></i>
                                {{ isExporting ? 'Export...' : 'Export Excel' }}
                            </button>
                        </div>
                    </div>

                    <!-- Stats Cards -->
                    <div class="stats-cards px-3 pt-2" *ngIf="stats">
                        <div class="row">
                            <div class="col-md-2 col-sm-4 col-6 mb-2">
                                <div class="stat-card">
                                    <div class="stat-value">{{ stats.total }}</div>
                                    <div class="stat-label">Total</div>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-4 col-6 mb-2">
                                <div class="stat-card stat-pending">
                                    <div class="stat-value">{{ stats.pending_lock }}</div>
                                    <div class="stat-label">Așteptare Blocare</div>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-4 col-6 mb-2">
                                <div class="stat-card stat-locked">
                                    <div class="stat-value">{{ stats.locked_not_generated }}</div>
                                    <div class="stat-label">Blocat (negenerat)</div>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-4 col-6 mb-2">
                                <div class="stat-card stat-generated">
                                    <div class="stat-value">{{ stats.generated_not_sent }}</div>
                                    <div class="stat-label">Generat (netrimis)</div>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-4 col-6 mb-2">
                                <div class="stat-card stat-completed">
                                    <div class="stat-value">{{ stats.completed }}</div>
                                    <div class="stat-label">Completat</div>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-4 col-6 mb-2">
                                <div class="stat-card stat-programari">
                                    <div class="stat-value">{{ stats.total_programari }}</div>
                                    <div class="stat-label">Total Programări</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Card Filtre -->
                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm">
                            <div class="row">
                                <!-- Modul -->
                                <div class="col-md-4">
                                    <mat-form-field>
                                        <mat-label>Modul</mat-label>
                                        <mat-select formControlName="id_modul" (openedChange)="onModuleSelectClosed()">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="moduleControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" placeholder="Căutare..." />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredModule.length === 0" disabled>
                                                <span>Nu s-au găsit rezultate</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Toate --</mat-option>
                                            <mat-option *ngFor="let modul of filteredModule" [value]="modul.id">
                                                {{ modul.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Locație -->
                                <div class="col-md-4">
                                    <mat-form-field>
                                        <mat-label>Locație</mat-label>
                                        <mat-select formControlName="id_locatie"
                                            (openedChange)="onLocatiiSelectClosed()">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="locatiiControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" placeholder="Căutare..." />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredLocatii.length === 0" disabled>
                                                <span>Nu s-au găsit rezultate</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Toate --</mat-option>
                                            <mat-option *ngFor="let locatie of filteredLocatii" [value]="locatie.id">
                                                {{ locatie.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Serviciu -->
                                <div class="col-md-4">
                                    <mat-form-field>
                                        <mat-label>Serviciu</mat-label>
                                        <mat-select formControlName="id_serviciu"
                                            (openedChange)="onServiciiSelectClosed()">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="serviciiControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" placeholder="Căutare..." />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredServicii.length === 0" disabled>
                                                <span>Nu s-au găsit rezultate</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Toate --</mat-option>
                                            <mat-option *ngFor="let serviciu of filteredServicii" [value]="serviciu.id">
                                                {{ serviciu.web_name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <!-- Data de la -->
                                <div class="col-md-3">
                                    <mat-form-field>
                                        <mat-label>Data programări de la</mat-label>
                                        <input matInput [matDatepicker]="dateFromPicker"
                                            formControlName="target_date_from" readonly (focus)="dateFromPicker.open()">
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateFromPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <!-- Data până la -->
                                <div class="col-md-3">
                                    <mat-form-field>
                                        <mat-label>Data programări până la</mat-label>
                                        <input matInput [matDatepicker]="dateToPicker" formControlName="target_date_to"
                                            readonly (focus)="dateToPicker.open()">
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateToPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <!-- Blocat -->
                                <div class="col-md-2">
                                    <mat-form-field>
                                        <mat-label>Blocat</mat-label>
                                        <mat-select formControlName="locked">
                                            <mat-option value="-1">-- Toate --</mat-option>
                                            <mat-option value="1">Da</mat-option>
                                            <mat-option value="0">Nu</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Borderou generat -->
                                <div class="col-md-2">
                                    <mat-form-field>
                                        <mat-label>Borderou generat</mat-label>
                                        <mat-select formControlName="borderou_generated">
                                            <mat-option value="-1">-- Toate --</mat-option>
                                            <mat-option value="1">Da</mat-option>
                                            <mat-option value="0">Nu</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Email trimis -->
                                <div class="col-md-2">
                                    <mat-form-field>
                                        <mat-label>Email trimis</mat-label>
                                        <mat-select formControlName="emails_sent">
                                            <mat-option value="-1">-- Toate --</mat-option>
                                            <mat-option value="1">Da</mat-option>
                                            <mat-option value="0">Nu</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>

                    <!-- Buton Filtre -->
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start align-items-center">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/icons8-filter-edit-50.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                    </div>

                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>